import React from 'react';
import styled, { withTheme, css } from 'styled-components';
import { PATHS } from '@constants/paths';

const isDarkBg = css`
  svg {
    background: #2b2927;
    border-radius: 9px;
    .border-color-android-app-store {
      fill: #2b2927;
    }
  }
`;

const Wrapper = styled.div`
  cursor: pointer;

  g {
    fill: ${(props) => (props.isDarkMode ? props.theme.secondary.white : props.theme.primary.charcoal)};
  }
  ${(props) => (props.isDarkBg ? isDarkBg : '')};
`;

function GooglePlay({ isDarkMode, theme, height, width, isDarkBg, onAfterClick }) {
  const fill = isDarkMode ? theme.secondary.white : theme.primary.charcoal;
  const handleClick = () => {
    window?.open(PATHS.GOOGLE_PLAY, '_blank').focus();
    onAfterClick && onAfterClick();
  };
  return (
    <Wrapper isDarkMode={isDarkMode} isDarkBg={isDarkBg} onClick={handleClick}>
      <svg width={width} height={height} viewBox="35 30 203 59" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d)">
          <path
            className="border-color-android-app-store"
            d="M230.743 31.1779C234.229 31.1779 237.065 33.9472 237.065 37.3505V81.4532C237.065 84.8565 234.229 87.6258 230.743 87.6258H42.5286C39.0428 87.6258 36.2065 84.8565 36.2065 81.4532V37.3505C36.2065 33.9472 39.0428 31.1779 42.5286 31.1779H230.743ZM230.743 30H42.5286C38.3897 30 35 33.3096 35 37.3505V81.4532C35 85.4942 38.3897 88.8037 42.5286 88.8037H230.743C234.882 88.8037 238.272 85.4942 238.272 81.4532V37.3505C238.272 33.3096 234.882 30 230.743 30Z"
          />
          <path
            d="M106.397 45.0591C106.397 46.2866 106.02 47.2698 105.279 48.003C104.426 48.8722 103.316 49.3095 101.955 49.3095C100.654 49.3095 99.5439 48.8648 98.633 47.9883C97.7201 47.0989 97.2646 46.0073 97.2646 44.7008C97.2646 43.3942 97.7201 42.3027 98.633 41.4206C99.5439 40.5367 100.654 40.092 101.955 40.092C102.602 40.092 103.22 40.2225 103.809 40.4651C104.396 40.7095 104.874 41.0403 105.22 41.4482L104.434 42.2237C103.83 41.5272 103.007 41.1836 101.955 41.1836C101.006 41.1836 100.184 41.507 99.4856 42.1594C98.7948 42.8135 98.4485 43.6607 98.4485 44.7008C98.4485 45.7409 98.7948 46.5954 99.4856 47.2496C100.184 47.8946 101.006 48.2253 101.955 48.2253C102.962 48.2253 103.809 47.8946 104.477 47.2422C104.917 46.8104 105.168 46.215 105.234 45.4542H101.955V44.3921H106.329C106.382 44.6218 106.397 44.8441 106.397 45.0591Z"
            stroke={fill}
            strokeWidth="0.180935"
            strokeMiterlimit="10"
          />
          <path
            d="M113.337 41.3765H109.229V44.1697H112.933V45.2319H109.229V48.025H113.337V49.1074H108.065V40.2942H113.337V41.3765Z"
            stroke={fill}
            strokeWidth="0.180935"
            strokeMiterlimit="10"
          />
          <path
            d="M118.234 49.1074H117.071V41.3765H114.551V40.2942H120.756V41.3765H118.234V49.1074Z"
            stroke={fill}
            strokeWidth="0.180935"
            strokeMiterlimit="10"
          />
          <path
            d="M125.247 49.1074V40.2942H126.408V49.1074H125.247Z"
            stroke={fill}
            strokeWidth="0.180935"
            strokeMiterlimit="10"
          />
          <path
            d="M131.556 49.1074H130.403V41.3765H127.873V40.2942H134.086V41.3765H131.556V49.1074Z"
            stroke={fill}
            strokeWidth="0.180935"
            strokeMiterlimit="10"
          />
          <path
            d="M145.834 47.9736C144.944 48.8648 143.841 49.3095 142.525 49.3095C141.202 49.3095 140.099 48.8648 139.209 47.9736C138.32 47.0842 137.878 45.9926 137.878 44.7008C137.878 43.4089 138.32 42.3174 139.209 41.428C140.099 40.5367 141.202 40.092 142.525 40.092C143.833 40.092 144.936 40.5367 145.826 41.4353C146.722 42.3321 147.164 43.4163 147.164 44.7008C147.164 45.9926 146.722 47.0842 145.834 47.9736ZM140.069 47.2349C140.739 47.8946 141.554 48.2253 142.525 48.2253C143.489 48.2253 144.311 47.8946 144.974 47.2349C145.642 46.5751 145.981 45.728 145.981 44.7008C145.981 43.6736 145.642 42.8264 144.974 42.1667C144.311 41.507 143.489 41.1762 142.525 41.1762C141.554 41.1762 140.739 41.507 140.069 42.1667C139.401 42.8264 139.062 43.6736 139.062 44.7008C139.062 45.728 139.401 46.5751 140.069 47.2349Z"
            stroke={fill}
            strokeWidth="0.180935"
            strokeMiterlimit="10"
          />
          <path
            d="M148.796 49.1074V40.2942H150.208L154.597 47.1485H154.647L154.597 45.4542V40.2942H155.758V49.1074H154.546L149.95 41.915H149.899L149.95 43.6166V49.1074H148.796Z"
            fill={fill}
            stroke={fill}
            strokeWidth="0.180935"
            strokeMiterlimit="10"
          />
          <path
            d="M137.592 61.9783C134.056 61.9783 131.167 64.6061 131.167 68.2317C131.167 71.8279 134.056 74.4833 137.592 74.4833C141.136 74.4833 144.025 71.8279 144.025 68.2317C144.025 64.6061 141.136 61.9783 137.592 61.9783ZM137.592 72.0209C135.652 72.0209 133.982 70.457 133.982 68.2317C133.982 65.9769 135.652 64.4407 137.592 64.4407C139.533 64.4407 141.21 65.9769 141.21 68.2317C141.21 70.457 139.533 72.0209 137.592 72.0209ZM123.572 61.9783C120.028 61.9783 117.147 64.6061 117.147 68.2317C117.147 71.8279 120.028 74.4833 123.572 74.4833C127.114 74.4833 129.998 71.8279 129.998 68.2317C129.998 64.6061 127.114 61.9783 123.572 61.9783ZM123.572 72.0209C121.63 72.0209 119.955 70.457 119.955 68.2317C119.955 65.9769 121.63 64.4407 123.572 64.4407C125.513 64.4407 127.182 65.9769 127.182 68.2317C127.182 70.457 125.513 72.0209 123.572 72.0209ZM106.889 63.8949V66.5521H113.388C113.198 68.0369 112.69 69.1284 111.91 69.8892C110.962 70.808 109.484 71.8279 106.889 71.8279C102.889 71.8279 99.7574 68.6764 99.7574 64.7715C99.7574 60.8665 102.889 57.715 106.889 57.715C109.051 57.715 110.625 58.5401 111.786 59.6096L113.704 57.7371C112.08 56.2229 109.919 55.0597 106.889 55.0597C101.404 55.0597 96.7949 59.4166 96.7949 64.7715C96.7949 70.1263 101.404 74.4833 106.889 74.4833C109.853 74.4833 112.08 73.535 113.83 71.7562C115.624 70.005 116.183 67.5426 116.183 65.5543C116.183 64.9368 116.13 64.369 116.036 63.8949H106.889ZM175.109 65.9549C174.58 64.5565 172.948 61.9783 169.624 61.9783C166.331 61.9783 163.588 64.5124 163.588 68.2317C163.588 71.7342 166.302 74.4833 169.941 74.4833C172.882 74.4833 174.58 72.732 175.278 71.7121L173.095 70.2917C172.367 71.3317 171.375 72.0209 169.941 72.0209C168.516 72.0209 167.494 71.3832 166.839 70.1263L175.404 66.666L175.109 65.9549ZM166.376 68.0369C166.302 65.6259 168.294 64.3911 169.72 64.3911C170.838 64.3911 171.787 64.9368 172.103 65.7178L166.376 68.0369ZM159.414 74.1029H162.229V55.7267H159.414V74.1029ZM154.803 63.3712H154.708C154.076 62.6398 152.87 61.9783 151.341 61.9783C148.134 61.9783 145.202 64.7274 145.202 68.2519C145.202 71.7562 148.134 74.4833 151.341 74.4833C152.87 74.4833 154.076 73.8162 154.708 73.0628H154.803V73.9595C154.803 76.3503 153.494 77.6348 151.385 77.6348C149.664 77.6348 148.597 76.4219 148.157 75.4021L145.708 76.3999C146.414 78.0574 148.283 80.0972 151.385 80.0972C154.686 80.0972 157.471 78.2007 157.471 73.5865V62.3587H154.803V63.3712ZM151.582 72.0209C149.642 72.0209 148.017 70.435 148.017 68.2519C148.017 66.0486 149.642 64.4407 151.582 64.4407C153.494 64.4407 155.002 66.0486 155.002 68.2519C155.002 70.435 153.494 72.0209 151.582 72.0209ZM188.292 55.7267H181.557V74.1029H184.365V67.1401H188.292C191.41 67.1401 194.469 64.9368 194.469 61.4325C194.469 57.93 191.403 55.7267 188.292 55.7267ZM188.365 64.584H184.365V58.2828H188.365C190.462 58.2828 191.659 59.9826 191.659 61.4325C191.659 62.8548 190.462 64.584 188.365 64.584ZM205.724 61.9434C203.695 61.9434 201.585 62.8181 200.717 64.7568L203.209 65.7766C203.746 64.7568 204.732 64.426 205.775 64.426C207.232 64.426 208.709 65.2805 208.732 66.7892V66.9821C208.223 66.6954 207.136 66.271 205.797 66.271C203.113 66.271 200.379 67.7135 200.379 70.4056C200.379 72.868 202.577 74.4539 205.048 74.4539C206.938 74.4539 207.981 73.6214 208.636 72.653H208.732V74.0735H211.444V67.0244C211.444 63.7663 208.952 61.9434 205.724 61.9434ZM205.385 72.0135C204.467 72.0135 203.187 71.5688 203.187 70.457C203.187 69.0347 204.783 68.489 206.164 68.489C207.401 68.489 207.981 68.7554 208.732 69.1064C208.511 70.808 207.011 72.0135 205.385 72.0135ZM221.325 62.3458L218.097 70.3119H218.001L214.664 62.3458H211.636L216.65 73.4781L213.789 79.6727H216.723L224.449 62.3458H221.325ZM196.012 74.1029H198.828V55.7267H196.012V74.1029Z"
            fill={fill}
          />
          <path
            d="M50.7119 41.0827C50.2696 41.5347 50.0137 42.2385 50.0137 43.15V75.6611C50.0137 76.5725 50.2696 77.2764 50.7119 77.7284L50.8211 77.8276L69.4807 59.6169V59.1869L50.8211 40.9761L50.7119 41.0827Z"
            fill="url(#paint0_linear)"
          />
          <path
            d="M75.6944 65.6902L69.4814 59.6169V59.1869L75.7019 53.1135L75.8412 53.1926L83.2079 57.2849C85.3103 58.4463 85.3103 60.3574 83.2079 61.5261L75.8412 65.6112L75.6944 65.6902Z"
            fill="url(#paint1_linear)"
          />
          <path
            d="M75.8404 65.6109L69.4806 59.4016L50.7119 77.7282C51.4102 78.4448 52.5489 78.5312 53.8438 77.8145L75.8404 65.6109Z"
            fill="url(#paint2_linear)"
          />
          <path
            d="M75.8404 53.1926L53.8438 40.9889C52.5489 40.2796 51.4102 40.366 50.7119 41.0827L69.4806 59.4019L75.8404 53.1926Z"
            fill="url(#paint3_linear)"
          />
        </g>
        <defs>
          <filter
            id="filter0_d"
            x="0.0714417"
            y="0.892868"
            width="273.129"
            height="128.661"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
            <feOffset dy="5.82143" />
            <feGaussianBlur stdDeviation="17.4643" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <linearGradient
            id="paint0_linear"
            x1="67.8239"
            y1="75.9996"
            x2="43.1593"
            y2="50.7374"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#00A0FF" />
            <stop offset="0.0066" stopColor="#00A1FF" />
            <stop offset="0.2601" stopColor="#00BEFF" />
            <stop offset="0.5122" stopColor="#00D2FF" />
            <stop offset="0.7604" stopColor="#00DFFF" />
            <stop offset="1" stopColor="#00E3FF" />
          </linearGradient>
          <linearGradient
            id="paint1_linear"
            x1="85.9455"
            y1="59.3998"
            x2="49.5119"
            y2="59.3998"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFE000" />
            <stop offset="0.4087" stopColor="#FFBD00" />
            <stop offset="0.7754" stopColor="#FFA500" />
            <stop offset="1" stopColor="#FF9C00" />
          </linearGradient>
          <linearGradient
            id="paint2_linear"
            x1="72.3822"
            y1="56.0261"
            x2="38.9349"
            y2="21.7684"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF3A44" />
            <stop offset="1" stopColor="#C31162" />
          </linearGradient>
          <linearGradient
            id="paint3_linear"
            x1="45.9874"
            y1="88.5447"
            x2="60.9231"
            y2="73.2472"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#32A071" />
            <stop offset="0.0685" stopColor="#2DA771" />
            <stop offset="0.4762" stopColor="#15CF74" />
            <stop offset="0.8009" stopColor="#06E775" />
            <stop offset="1" stopColor="#00F076" />
          </linearGradient>
        </defs>
      </svg>
    </Wrapper>
  );
}

export default withTheme(GooglePlay);
